import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const eventDateTimePickerStyles: SxProps<Theme> = {
	'&.MuiPickersLayout-root': {
		backgroundColor: Colors.black_a60,
		backdropFilter: 'blur(20px)',
		borderRadius: '6px',
		transitionDuration: '0.5s',
		transitionProperty: 'all',
	},

	'& .MuiDateCalendar-root': {
		"& .MuiPickersCalendarHeader-root": {
			p: '0 32px 0 20px',

			'& .MuiPickersCalendarHeader-labelContainer': {
				'& .MuiPickersCalendarHeader-label': {
					fontFamily: 'Montserrat, sans-serif',
					fontSize: '15px',
					fontWeight: 500,
					lineHeight: '18px',
					color: Colors.white_a80,
					mr: '2px',
				},

				'& .MuiButtonBase-root': {
					p: 0,
				}
			},

			"& .MuiPickersArrowSwitcher-root": {
				'& .MuiPickersArrowSwitcher-spacer': {
					width: '50px',
				},

				'& .MuiButtonBase-root': {
					width: '24px',
					height: '24px',
					p: 0,
					fontSize: '20px',
				}
			}
		},

		'& .MuiDayCalendar-header': {
			'& .MuiDayCalendar-weekDayLabel': {
				fontFamily: 'Roboto, sans-serif',
				fontSize: '12px',
				lineHeight: '16px',
				fontWeight: '400',
				color: Colors.white_a80,
			},
		},

		'& .MuiPickersDay-root': {
			fontFamily: 'Roboto, sans-serif',
			color: Colors.white_a87,
			fontSize: '16px',
			lineHeight: '24px',
			fontWeight: 400,
			width: '36px',
			height: '36px',

			"&.Mui-selected": {
				backgroundColor: Colors.white,
				color: Colors.black,
			},

			'&.Mui-disabled:not(.Mui-selected)': {
				color: Colors['969696'],
			},
		},

		'& .MuiYearCalendar-root': {
			'& .MuiPickersYear-root': {
				'& .MuiPickersYear-yearButton': {
					fontFamily: 'Roboto, sans-serif',
					color: Colors.white_a87,
					fontSize: '16px',
					lineHeight: '24px',
					fontWeight: 400,

					"&.Mui-selected": {
						backgroundColor: Colors.white,
						color: Colors.black,
					},

					'&.Mui-disabled:not(.Mui-selected)': {
						color: Colors['969696'],
					},
				}
			}
		}
	},
};
